<template>
    <div class="card mb-10 border-0 rounded-0 bg-white letter-spacing ticket-grid-box">
        <div class="card-body p-15 p-sm-20 p-md-25">
            <div class="item    p-2" v-for="item in priceData" :key= "item.id" @click="chooose(item)">
                <div class="d-md-flex align-items-center justify-content-between m-0 p-0 row "  style="cursor:pointer;">
                    <div class="d-sm-flex align-items-center col-xl-8 col-lg-8 col-md-6 col-sm-6 ">
                        <div class="form-check mb-0 ">
                            <input class="form-check-input shadow-none" type="radio"  :name="item.id"
                            :id="item.id"  v-model="chooseFlag" :value="item.id" >
                        </div>
                        <div class="mt-10 mt-sm-0 ms-sm-8">
                            <div class="d-sm-flex mb-8">
                                <span
                                    class="d-block fw-bold text-decoration-none fw-medium fs-md-16 fs-lg-16">
                                    {{item.title}}
                            </span>
                                <span class="badge text-outline-success mt-10 mt-sm-0 ms-sm-10" v-if="item.type=='year'">推荐</span>
                            </div>
                            <div class="d-flex align-items-center  fs-md-15 fs-lg-16">
                                {{item.days}}天使用时长
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center mt-10 mt-md-0 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <small>￥</small>
                        <span class="fs-lg-30 fs-sm-10">{{item.price}}</span>
                        <small class="fs-lg-10 fs-sm-10">/{{item.dayPrice}}天</small>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>

export default {
    name: "Pricing",

    props: {
        priceData: {}
    },

    data: function () {
        return {
            username: '',
            password: '',
            email: '',
            loading: false,
            viplist: [],
            chooseFlag:'',

        };
    },
    mounted(){
    },

    methods: {
        chooose(item) {
            this.chooseFlag = item.id;
            this.$emit('chooseCard', item);
        }
    }


};
</script>

<style scoped>
 
</style>